import { useAssetServices } from '@/hooks/asset-services.hooks';
import { useAsset, useAssetParams } from '@/hooks/asset.hooks';
import { extractEntitySavings, getServicePrice } from '@/utils/services.utils';
import { getAppConfig } from '@/utils/window.utils';

export const useAssetPriceContents = () => {
    const { assetType, assetId } = useAssetParams();
    const { data } = useAsset(assetType, assetId);
    const config = getAppConfig();
    const assetServices = useAssetServices(data);
    const priceValueField = config.feature.priceExclTax?.enable ? 'priceExclTax' : 'priceInclTax';

    let delivery = 0;
    let services = 0;
    let servicesTax = 0;

    for (const service of assetServices) {
        const servicePrice = getServicePrice(service, priceValueField);

        if (service.isDelivery) {
            const savings = extractEntitySavings(service);
            delivery += servicePrice + savings.reduce((acc, curr) => acc + (curr.amount ?? 0), 0);
        } else {
            services += servicePrice;
            servicesTax += (service.price?.priceInclTax ?? 0) - (service.price?.priceExclTax ?? 0);
        }
    }

    return {
        delivery,
        services,
        servicesTax,
    };
};
